<template>
        <!-- :style="`width: ${dynamicModalData && dynamicModalData.width || 40}vw; height: ${dynamicModalData && dynamicModalData.height ? dynamicModalData.height : 70}vh !important;`" -->
    <Dialog
        ref="dialogMainref"
        v-model:visible="showDialog"
        class="dynamicModal"
        :maximizable="true"
        :style="`width: ${(dynamicModalData && dynamicModalData.modal_width) || 40}vw;`"
        :fullscreen="
            dynamicModalData && dynamicModalData.fullscreen
                ? dynamicModalData.fullscreen
                : false
        "
        modal="modal"
        :dismissableMask="dynamicModalData && dynamicModalData.dismiss !== undefined ? dynamicModalData.dismiss : false"
        :closable="dynamicModalData && dynamicModalData.closable !== undefined
                ? dynamicModalData.closable
                : true"
        :closeOnEscape="dynamicModalData && dynamicModalData.closeOnEscape !== undefined
                ? dynamicModalData.closeOnEscape
                : true"
        @hide="hideDialog"
        @show="openDialog"
    >
        <template #header>
            <div class="w-100 text-center">
                <div
                    class="fs-6 fw-bold"
                    v-html="
                        dynamicModalData && dynamicModalData.title !== undefined
                            ? dynamicModalData.title
                            : ''
                    "
                ></div>
                <div
                    class="small text-secondary"
                    v-html="
                        dynamicModalData &&
                        dynamicModalData.subTitle !== undefined
                            ? dynamicModalData.subTitle
                            : ''
                    "
                ></div>
            </div>
        </template>
        <!-- <component v-if="dynamicModal" :is="dynamicModal" :data="dynamicModalData"></component> -->
        <!-- <div :style="'' + (dynamicModalData.modalToolbar ? 'height: 50vh; margin-bottom: 60px' : '; height: 60vh')"> -->
        <!-- <div style="max-height: 75vh"> -->
        <div class="max-h-751">
            <component
                v-model:mainref="dialogref"
                v-if="dynamicModal"
                :is="dynamicModal"
                :data="dynamicModalData"
            ></component>
        </div>

        <template #footer v-if="dynamicModalData && dynamicModalData.toolbar">
            <DAToolbar v-model:mainref="dialogref" :data="dynamicModalData" />
        </template>
    </Dialog>
</template>


<script>
    import {
        ref,
        computed,
        defineAsyncComponent,
        watchEffect,
        onMounted,
    } from "vue";

    // import { useStore } from "@/system_modules/store";

    import Dialog from "primevue/dialog";
    // import Button from "primevue/button";

    import { G } from "@/_common";

    import DAToolbar from "@/components/toolbar/DAToolbar";

    export default {
        name: "MoDal",
        components: {
            Dialog,
            // Button,
            DAToolbar,
        },
        setup() {
            // const store = useStore();

            const dialogref = ref({});
            const dialogMainref = ref({});
            // const TR = ref();

            const showDialog = ref();
            const dpage = ref(null);
            const dynamicModalData = ref(null);

            onMounted(() => {
                showDialog.value = false;
                dialogref.value = {};
            });

            watchEffect(() => {
                // TR.value = store.getTranslation();
                // dpage.value = G.modalPage.value;
                // dynamicModalData.value = G.modalData.value;
                // dpage.value = store.getModalPage();
                // dynamicModalData.value = store.getModalData();


                dpage.value = G.modal.page;
                // dynamicModalData.value = G.modal.data;
                if (dpage.value != null) {
                    showDialog.value = true;
                } else {
                    showDialog.value = false;
                }
            });

            const hideDialog = () => {
                // if onModalClose is present the they must this function
                // G.closeModal();
                // in his body
                if (dynamicModalData.value && dynamicModalData.value.onModalClose){
                    dynamicModalData.value.onModalClose(dialogref.value);
                    // showDialog.value = false;
                    // dialogref.value = {};
                    // G.closeModal();
                }
                else{
                    showDialog.value = false;
                    dialogref.value = {};

                    G.modal.page = null;
                    G.modal.data = null;
                    dynamicModalData.value = null;

                    // console.log('hide dialog');
                }
                // console.log(dynamicModalData.value);
            };

            const openDialog = () => {
                dpage.value = G.modal.page;
                dynamicModalData.value = G.modal.data;
                if (dynamicModalData.value && dynamicModalData.value.onModalOpen !== undefined){
                    dynamicModalData.value.onModalOpen(dynamicModalData.value);
                }
            };

            const dynamicModal = computed(() => {
                if (dpage.value) {
                    return defineAsyncComponent({
                        loader: () => import(`@/${dpage.value}`),
                        loadingComponent:
                            '<center><i class="fa fa-sync fa-spin"></i></center>',
                        errorComponent: //defineAsyncComponent(() =>
                            import("@/system_modules/NotFound")
                        //),
                        // timeout: 3000,
                        // suspensible: false,
                    });
                } else {
                    return defineAsyncComponent({
                        loader: () => import(`@/system_modules/NotFound`)
                    });
                }
            });

            return {
                dialogref,
                dialogMainref,
                showDialog,
                hideDialog,
                openDialog,
                dynamicModal,
                dynamicModalData,
            };
        },
    };
</script>


<style lang="scss">
    .p-dialog {
        // max-height: 90vh;
        -webkit-transform: unset;
        transform: unset;
    }
    // .p-overflow-hidden {
    //     overflow: unset;
    // }

    .p-component-overlay-enter {
        // -webkit-animation: p-component-overlay-enter-animation 150ms forwards;
        // animation: p-component-overlay-enter-animation 150ms forwards;
        -webkit-animation: unset;
        animation: unset;
        transform: unset;
    }
    .p-component-overlay {
        background-color: rgba(0, 0, 0, 0.4);
        transition-duration: unset;
        transform: unset;
    }

    .p-dialog .p-dialog-content {
        padding: 0.2rem;
        // max-height: 70vh;
        // min-height: 50vh;
        // height: auto;
        min-height: calc(100vh - 300px);
        height: calc(100vh - 300px);
    }
    .p-dialog .p-dialog-header {
        border-bottom: 1px solid #c4bdbd;
        padding: 0.5rem 0.9rem;
    }
    .p-dialog .p-dialog-footer {
        border-top: 1px solid #c4bdbd;
        // padding: 1rem;
        padding: 0.6rem 0.9rem;
    }

    // .p-datepicker {
    //     width: 350px !important;
    // }
    .p-datepicker table td > span {
        width: 2rem !important;
        height: 2rem !important;
    }

    .p-dialog-enter-active {
        transition: unset;
    }
    .p-dialog-leave-active {
        transition: unset;
    }

    // .p-dialog-enter-from,
    // .p-dialog-leave-to {
    //     opacity: 0;
    //     transform: unset;
    // }
    // .p-dialog-top .p-dialog,
    // .p-dialog-bottom .p-dialog,
    // .p-dialog-left .p-dialog,
    // .p-dialog-right .p-dialog,
    // .p-dialog-topleft .p-dialog,
    // .p-dialog-topright .p-dialog,
    // .p-dialog-bottomleft .p-dialog,
    // .p-dialog-bottomright .p-dialog {
    //     margin: .75rem;
    //     transform: unset;
    // }
    // .p-dialog-top .p-dialog-enter-active,
    // .p-dialog-top .p-dialog-leave-active,
    // .p-dialog-bottom .p-dialog-enter-active,
    // .p-dialog-bottom .p-dialog-leave-active,
    // .p-dialog-left .p-dialog-enter-active,
    // .p-dialog-left .p-dialog-leave-active,
    // .p-dialog-right .p-dialog-enter-active,
    // .p-dialog-right .p-dialog-leave-active,
    // .p-dialog-topleft .p-dialog-enter-active,
    // .p-dialog-topleft .p-dialog-leave-active,
    // .p-dialog-topright .p-dialog-enter-active,
    // .p-dialog-topright .p-dialog-leave-active,
    // .p-dialog-bottomleft .p-dialog-enter-active,
    // .p-dialog-bottomleft .p-dialog-leave-active,
    // .p-dialog-bottomright .p-dialog-enter-active,
    // .p-dialog-bottomright .p-dialog-leave-active {
    //     transition: unset;
    // }
    // .p-dialog-top .p-dialog-enter-from,
    // .p-dialog-top .p-dialog-leave-to {
    //     transform: unset;
    // }
    // .p-dialog-bottom .p-dialog-enter-from,
    // .p-dialog-bottom .p-dialog-leave-to {
    //     transform: unset;
    // }
    // .p-dialog-left .p-dialog-enter-from,
    // .p-dialog-left .p-dialog-leave-to,
    // .p-dialog-topleft .p-dialog-enter-from,
    // .p-dialog-topleft .p-dialog-leave-to,
    // .p-dialog-bottomleft .p-dialog-enter-from,
    // .p-dialog-bottomleft .p-dialog-leave-to {
    //     transform: unset;
    // }
    // .p-dialog-right .p-dialog-enter-from,
    // .p-dialog-right .p-dialog-leave-to,
    // .p-dialog-topright .p-dialog-enter-from,
    // .p-dialog-topright .p-dialog-leave-to,
    // .p-dialog-bottomright .p-dialog-enter-from,
    // .p-dialog-bottomright .p-dialog-leave-to {
    //     transform: unset;
    // }

    // .p-dialog-maximized {
    //     -webkit-transition: unset;
    //     transition: unset;
    //     transform: unset;
    //     width: 100vw !important;
    //     height: 100vh !important;
    //     top: 0px !important;
    //     left: 0px !important;
    //     max-height: 100%;
    //     height: 100%;
    // }





    @media (max-width: 576px) {
        .dynamicModal {
            width: 100vw !important;
        }
    }
</style>
